module.exports = __webpack_public_path__ + "static/assets/48abf6b6ae617f4a1d45826e915e03f3.png";